import { ON_CHANGE_DEBOUNCE_TIMER } from '@/scripts/core/global'
import { fetchConfig } from '@/scripts/core/global';
import { TsDOM as q, debounce } from '@/scripts/core/TsDOM'
import { UcoastEl } from '@/scripts/core/UcoastEl';
import {
	getDOMCartSectionApiIds,
	renderResponseToCartDrawer,
} from '@/scripts/core/cart-functions'

export class CartNote extends UcoastEl {
	static htmlSelector = 'cart-note'
	input: HTMLTextAreaElement
	fieldCount: HTMLElement
	propertyInput?: HTMLInputElement
	submitButton?: HTMLButtonElement
	constructor() {
		super()
		this.input = q.rs('textarea', this)
		this.fieldCount = q.rs('.cart__note-field-count', this)
		this.propertyInput = q.os<HTMLInputElement>('input[name="note"]', this)
		this.submitButton = q.os<HTMLButtonElement>('[data-uc-cart-note-submit]', this)

		this.input.addEventListener(
			'change',
			debounce((event: Event) => {
				const target = q.rt<Event, HTMLTextAreaElement>(event)
				void this.updateCartNote(target.value)
			}, ON_CHANGE_DEBOUNCE_TIMER)
		)

		this.input.addEventListener('input', this.onChangeInput.bind(this))
		this.submitButton?.addEventListener('click', this.onSubmitHandler.bind(this))
	}

	onChangeInput() {
		const noteSize = this.input.value.length
		this.fieldCount.textContent = `${noteSize} / 280`
		if (!this.propertyInput) return
		this.propertyInput.value = this.input.value
		this.propertyInput.disabled = this.input.value.length == 0
	}

	async onSubmitHandler(event: Event) {
		event.preventDefault()
		if (!this.submitButton) return
		if (this.submitButton.getAttribute('aria-disabled') === 'true') return

		this.submitButton.setAttribute('aria-disabled', 'true')
		try {
			const cart = await this.updateCartNote(this.input.value, true)
			if (cart) renderResponseToCartDrawer(cart)
		} catch (error) {
			console.error(error)
		} finally {
			this.submitButton.removeAttribute('aria-disabled')
		}
	}

	async updateCartNote(note: string, includeSections = false) {
		const sections = includeSections ? getDOMCartSectionApiIds() : undefined
		const body = JSON.stringify({
			note,
			...(sections ? { sections } : {}),
		})
		const response = await fetch(`${window.routes.cart_update_url}`, {
			...fetchConfig(),
			...{ body },
		})
		const cart = await response.json()
		if (cart.status) {
			throw new Error(cart.description || cart.message)
		}
		return includeSections ? cart : undefined
	}
}
